import _objectSpread from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
// Implementation forked and adapted from https://github.com/MetaMask/eth-sig-util/blob/main/src/sign-typed-data.ts
import { encodeAbiParameters } from '../abi/encodeAbiParameters.js';
import { concat } from '../data/concat.js';
import { toHex } from '../encoding/toHex.js';
import { keccak256 } from '../hash/keccak256.js';
import { getTypesForEIP712Domain, validateTypedData } from '../typedData.js';
export function hashTypedData(_ref) {
  let {
    domain: domain_,
    message,
    primaryType,
    types: types_
  } = _ref;
  const domain = typeof domain_ === 'undefined' ? {} : domain_;
  const types = _objectSpread({
    EIP712Domain: getTypesForEIP712Domain({
      domain
    })
  }, types_);
  // Need to do a runtime validation check on addresses, byte ranges, integer ranges, etc
  // as we can't statically check this with TypeScript.
  validateTypedData({
    domain,
    message,
    primaryType,
    types
  });
  const parts = ['0x1901'];
  if (domain) parts.push(hashDomain({
    domain,
    types: types
  }));
  if (primaryType !== 'EIP712Domain') {
    parts.push(hashStruct({
      data: message,
      primaryType: primaryType,
      types: types
    }));
  }
  return keccak256(concat(parts));
}
export function hashDomain(_ref2) {
  let {
    domain,
    types
  } = _ref2;
  return hashStruct({
    data: domain,
    primaryType: 'EIP712Domain',
    types
  });
}
function hashStruct(_ref3) {
  let {
    data,
    primaryType,
    types
  } = _ref3;
  const encoded = encodeData({
    data,
    primaryType,
    types
  });
  return keccak256(encoded);
}
function encodeData(_ref4) {
  let {
    data,
    primaryType,
    types
  } = _ref4;
  const encodedTypes = [{
    type: 'bytes32'
  }];
  const encodedValues = [hashType({
    primaryType,
    types
  })];
  for (const field of types[primaryType]) {
    const [type, value] = encodeField({
      types,
      name: field.name,
      type: field.type,
      value: data[field.name]
    });
    encodedTypes.push(type);
    encodedValues.push(value);
  }
  return encodeAbiParameters(encodedTypes, encodedValues);
}
function hashType(_ref5) {
  let {
    primaryType,
    types
  } = _ref5;
  const encodedHashType = toHex(encodeType({
    primaryType,
    types
  }));
  return keccak256(encodedHashType);
}
function encodeType(_ref6) {
  let {
    primaryType,
    types
  } = _ref6;
  let result = '';
  const unsortedDeps = findTypeDependencies({
    primaryType,
    types
  });
  unsortedDeps.delete(primaryType);
  const deps = [primaryType, ...Array.from(unsortedDeps).sort()];
  for (const type of deps) {
    result += "".concat(type, "(").concat(types[type].map(_ref7 => {
      let {
        name,
        type: t
      } = _ref7;
      return "".concat(t, " ").concat(name);
    }).join(','), ")");
  }
  return result;
}
function findTypeDependencies(_ref8) {
  let {
    primaryType: primaryType_,
    types
  } = _ref8;
  let results = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
  const match = primaryType_.match(/^[0-9A-Z_a-z]*/);
  const primaryType = match === null || match === void 0 ? void 0 : match[0];
  if (results.has(primaryType) || types[primaryType] === undefined) {
    return results;
  }
  results.add(primaryType);
  for (const field of types[primaryType]) {
    findTypeDependencies({
      primaryType: field.type,
      types
    }, results);
  }
  return results;
}
function encodeField(_ref9) {
  let {
    types,
    name,
    type,
    value
  } = _ref9;
  if (types[type] !== undefined) {
    return [{
      type: 'bytes32'
    }, keccak256(encodeData({
      data: value,
      primaryType: type,
      types
    }))];
  }
  if (type === 'bytes') {
    const prepend = value.length % 2 ? '0' : '';
    value = "0x".concat(prepend + value.slice(2));
    return [{
      type: 'bytes32'
    }, keccak256(value)];
  }
  if (type === 'string') return [{
    type: 'bytes32'
  }, keccak256(toHex(value))];
  if (type.lastIndexOf(']') === type.length - 1) {
    const parsedType = type.slice(0, type.lastIndexOf('['));
    const typeValuePairs = value.map(item => encodeField({
      name,
      type: parsedType,
      types,
      value: item
    }));
    return [{
      type: 'bytes32'
    }, keccak256(encodeAbiParameters(typeValuePairs.map(_ref10 => {
      let [t] = _ref10;
      return t;
    }), typeValuePairs.map(_ref11 => {
      let [, v] = _ref11;
      return v;
    })))];
  }
  return [{
    type
  }, value];
}
//# sourceMappingURL=hashTypedData.js.map